import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import { TripBenefitsQuery } from '../../../gql/graphql';
import { FC, useState } from 'react';
import { Collapse } from '@mui/material';

interface Props {
  tripBenefit: TripBenefitsQuery | undefined;
}

const TripBenefit: FC<Props> = ({ tripBenefit }) => {
  const [benefitOpen, setBenefitOpen] = useState(true);
  return (
    <div className="flex flex-col items-start gap-4">
      <button
        className="flex items-center gap-2 text-neutral-800"
        type="button"
        onClick={() => setBenefitOpen(!benefitOpen)}
      >
        <span className="font-semibold text-sm">Trip included/excluded</span>
        <span>
          {benefitOpen ? (
            <IconChevronDown size={16} />
          ) : (
            <IconChevronUp size={16} />
          )}
        </span>
      </button>
      <Collapse in={benefitOpen} timeout="auto" unmountOnExit>
        <div className="flex p-4 flex-col items-start gap-4 self-stretch bg-neutral-50 rounded-lg md:bg-neutral-00">
          <div className="flex flex-col items-start gap-2 self-stretch">
            <span className="text-sm text-neutral-800 font-semibold">
              Trip included
            </span>
            <div className="flex text-xs text-neutral-500 items-start content-start gap-1 self-stretch flex-wrap">
              {tripBenefit?.tripBenefits
                .filter(x => x.isInclusion)
                .map((benefit, index, filteredBenefits) => (
                  <div key={benefit.benefitId}>
                    <span>
                      {benefit.benefitName.replace(
                        '{0}',
                        benefit.benefitValue.toString(),
                      )}
                    </span>
                    {/* Add a bullet separator except for the last item */}
                    {index < filteredBenefits.length - 1 && (
                      <span className="mx-2">•</span>
                    )}
                  </div>
                ))}
            </div>
          </div>
          <div className="flex flex-col items-start gap-2 self-stretch">
            <span className="text-sm text-neutral-800 font-semibold">
              Trip excluded
            </span>
            <div className="flex text-xs text-neutral-500 items-start content-start gap-1 self-stretch flex-wrap">
              {tripBenefit?.tripBenefits
                .filter(x => !x.isInclusion)
                .map((benefit, index, filteredBenefits) => (
                  <div key={benefit.benefitId}>
                    <span>
                      {benefit.benefitName.replace(
                        '{0}',
                        benefit.benefitValue.toString(),
                      )}
                    </span>
                    {/* Add a bullet separator except for the last item */}
                    {index < filteredBenefits.length - 1 && (
                      <span className="mx-2"> • </span>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default TripBenefit;
